// src/components/Footer.js
import React from "react";
import "../styles/Footer.css";
import { FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="contact-info">
          <h3>Contact Us</h3>
          <p>Casper, Wyoming, USA</p>
          <p>Email: info@quila.today</p>
        </div>
        <div className="social-links">
          <h3>Follow Us</h3>
          <a
            href="https://www.linkedin.com/company/quila-llc"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://www.instagram.com/quila.today/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Quila LLC Website. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
